import { request } from "../../httpClient";

export const updateUserRequest = async (values) => {
  const res = await request({
    path: "user/protected/user-update",
    method: "POST",
    body: JSON.stringify(values),
  });
  return res;
};
